import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { HttpError } from '../../api';
import ErrorScreen from '../../core-components/theme/components/ErrorScreen';
import { NoAccessScreen } from '../components/NoAccessScreen';

const FORBIDDEN = 403;

const statusOf = (error: unknown): number | null => {
  if (isRouteErrorResponse(error)) return error.status;
  if (error instanceof HttpError) return error.status;
  return null;
};

export const RouteErrorScreen = () => {
  const error = useRouteError();
  if (statusOf(error) === FORBIDDEN) return <NoAccessScreen reason="NOT_GRANTED" />;
  return <ErrorScreen />;
};
